export function destinationMergeChecker(arr: any[]): any[] {
  arr.forEach((day: any, index: any) => {
    if (index !== 0) {
      arr[index].isMerged = arr[index - 1]?.destination === day?.destination;
    }else{
      arr[index].isMerged = false;
    }
  });
  return arr;
}
